(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[231],{

/***/ "S5GU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/price-ticket/priceTicket.mapper.js
var priceTicket_mapper = __webpack_require__("XiXw");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/price-ticket/PriceTicketContentWrapper.jsx + 2 modules
var PriceTicketContentWrapper = __webpack_require__("VQXK");

// CONCATENATED MODULE: ./src/client/components/lines/product-price-ticket-custom/ProductPriceTicketCustom.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ProductPriceTicketCustom_ProductPriceTicketCustom = function ProductPriceTicketCustom(_ref) {
  var config = _ref.config,
      getAQuoteCTA = _ref.getAQuoteCTA,
      getAQuoteURL = _ref.getAQuoteURL,
      resort = _ref.resort;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  Object(i18n["a" /* addTranslationKeys */])(_objectSpread(_objectSpread({}, config), {}, {
    productPriceTicketMiceLine: {
      getAQuoteCTA: getAQuoteCTA,
      getAQuoteURL: getAQuoteURL
    }
  }));
  var priceTicketContentProps = {
    button: {
      children: getAQuoteCTA,
      trackingData: {
        actionGA: 'priceBar',
        categoryGA: pageType,
        labelGA: 'getAQuote'
      },
      url: getAQuoteURL
    },
    fromPriceTicketCustom: true,
    price: resort.mice,
    subtitle: Object(priceTicket_mapper["c" /* getPriceTicketSubtitle */])(resort),
    title: resort.name
  };
  return __jsx("div", {
    className: "Line Line-PriceTicketCustom relative z-3"
  }, __jsx(PriceTicketContentWrapper["a" /* PriceTicketContentWrapper */], priceTicketContentProps));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-ticket-custom/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductPriceTicketCustom_ProductPriceTicketCustom);

/***/ })

}]);